var _defs, _polygon, _path, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GV_Light",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3840 3840",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6e6e6;}.cls-2{fill:#ffc33e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tavola disegno 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1296.66 2052.33 1984.6 2052.33 1826.76 1752.33 1296.66 1752.33 1296.66 2052.33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1296.66,2699.37c-439.49,0-797-357.55-797-797s357.55-797,797-797a795.56,795.56,0,0,1,203.54,26.34L1328.75,805.76q-16-.45-32.09-.47c-148,0-291.72,29-427.06,86.27a1099.88,1099.88,0,0,0-583.71,583.71c-57.25,135.34-86.27,279-86.27,427.06s29,291.72,86.27,427.07A1099.75,1099.75,0,0,0,869.6,2913.1c135.34,57.25,279,86.27,427.06,86.27s291.72-29,427.07-86.27a1100.93,1100.93,0,0,0,482.53-397.3q6.27-9.27,12.34-18.7l-171.53-326C1936.55,2478.74,1641.89,2699.37,1296.66,2699.37Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3301.39 805.76 2317.17 2676.49 2486.66 2998.65 3640.38 805.76 3301.39 805.76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.b8d3c5d70990603a47cde354ec61e760.svg";
export { ForwardRef as ReactComponent };